<script setup>
import { watch, inject, ref } from 'vue'
import gsap from 'gsap'
const { screen } = inject('Shared')

const disabled = ref(false)

const members = ref([
  {
    firstName: 'Ivan',
    lastName: 'Beldi',
    open: false,
    email: 'ivan@raumpioniere.ch',
    position: 'Verwaltungsrat',
    img: require('../../assets/img/aboutUs/Ivan.png'),
    title: 'Ivan ist studierter Betriebswirtschaftler mit einer Leidenschaft für Design und Architektur. Mit 25 Jahren Erfahrung in der Unternehmensberatung unterstützt er die Raumpioniere in der Geschäftsausrichtung, im Zahlenwerk, aber auch leidenschaftlich im Austausch mit Kunden und Geschäftspartnern.',
    description: `
        </div>
          <div style="font-weight: 600">Was Ivan mag:</div>
          <div>Ergebnisse (im Geschäft), steile Hänge (beim Skifahren), raues Wasser (beim Segeln), grosse Weiten (beim Motorradfahren), Ideen (für eine bessere (Um)Welt), aber besonders Geselligkeit und positive Leute, um gemeinsam spannende Themen voranzutreiben.</div>
          <br>
          <div style="font-weight: 600">Was Ivan nicht mag:</div>
          <div>Enge Grenzen, Windstille, negative Einstellungen, Personen, die einseitig (aus eidgenössischer Perspektive) den Rest der Welt (be)urteilen, Untätigkeit … und chinesisches Essen.</div>
        </div>
      `
  },
  {
    firstName: 'Elia',
    lastName: 'Bruno',
    open: false,
    email: 'elia@raumpioniere.ch',
    position: 'Advisor',
    img: require('../../assets/img/aboutUs/Elia.png'),
    title: 'Elia ist Betriebsökonom und Immobilienprofi mit grosser Erfahrung im Bereich der Projektentwicklung. Er unterstütz die Raumpioniere insbesondere in der Strukturierung und Abwicklung von Immobilientransaktionen.',
    description: `
        </div>
          <div style="font-weight: 600">Was Elia mag:</div>
          <div>Kids & Family, Wandern, Sport, den Bodensee, Wine & Dine, und alles was mit Immobilien zu tun hat.</div>
          <br>
          <div style="font-weight: 600">Was Elia nicht mag:</div>
          <div>Pessimisten, Jasager, Ungerechtigkeit, Wirbel um Nichts und Meeresfrüchte.</div>
        </div>
      `
  },
  {
    firstName: 'Bartek',
    lastName: 'Domek',
    open: false,
    email: 'bartek@raumpioniere.ch',
    position: 'Technologie',
    img: require('../../assets/img/aboutUs/Bartek.png'),
    title: `
          <div>Bartek ist ein erfahrener Front- und Backend Engineer mit dem wichtigen Blick fürs Ganze. Er war viele Jahre lang CTO bei 24technology und gestaltet und leitet jetzt die System-Architektur und Entwicklung der RAUMPIONIERE-Plattform.</div>
        `,
    description: `
      </div>
        <div style="font-weight: 600">Was Bartek mag:</div>
        <div>Zeit mit meiner süssen Tochter verbringen, Ninjutsu, Tauchen, italienischen Rotwein, Snowboarden und original neapolitanischen Espresso.</div>
        <br>
        <div style="font-weight: 600">Was Bartek nicht mag:</div>
        <div>Lieblichen Wein, Micromanagement, Blumenkohl und in FIFA zu verlieren.</div>
      </div>
    `
  },
  {
    firstName: 'Andreas',
    lastName: 'Trunz',
    open: false,
    email: 'andreas@raumpioniere.ch',
    position: 'Verkauf & Vermarktung',
    img: require('../../assets/img/aboutUs/Andreas.png'),
    title: 'Andy ist voll am Puls unserer Kundschaft und liebt es, Eigentümerinnen und Eigentümer zu begleiten, wenn es für sie um die Ermittlung und Realisierung von Potenzialen geht. Als Bergsteiger setzt er sich gerne kühne Ziele zu erreichen und gibt dann alles, um sie auch sicher zu erreichen.',
    description: `
      </div>
        <strong>Was Andy mag:</strong>
        <div>Querdenken, geradliniges Handeln, Kontraste,</div>
        <div>die menschliche Imperfektion und Fels & Schnee.</div>
        <div style="padding-top: 30px; font-weight: 600">Was Andy nicht mag:</div>
        <div>Egozentrismus, Ethnozentrismus und Chnoblihummus.</div>
      </div>
    `
  },
  {
    firstName: 'Attila',
    lastName: 'Färber',
    open: false,
    email: 'atilla@raumpioniere.ch',
    position: 'Gesamtleitung',
    img: require('../../assets/img/aboutUs/Atilla.png'),
    title: 'Atilla orchestriert die Raumpioniere – als offener, warmherziger Zeitgenosse, studierter Architekt, der als Consultant im fernen China schon ganze Regionen beraten, und zudem eine grosse Affinität für smarte Tech-Lösungen wie unseren Potenzialrechner hat, fällt ihm das nicht wirklich schwer.',
    description: `
      </div>
        <div style="font-weight: 600">Was Atilla mag:</div>
        <div>Kids & Family, Bewegung, Sport, ältere Menschen – und ihre Geschichten, Sommer & Schnee, St. Gallen, Kiesstrände, Holzdecks, Essen gehen und Wienerschnitzel & Räuberspiesse.</div>
        <br>
        <div style="font-weight: 600">Was Atilla nicht mag:</div>
        <div>Schlechte Laune, Rappenspalter, Choleriker, Rücksichtslosigkeit,  Hektik und den Flughafen Frankfurt.</div>
      </div>
    `
  },
  {
    firstName: 'Christoph',
    lastName: 'Giger',
    open: false,
    email: 'christoph@raumpioniere.ch',
    position: 'Architektur & Entwicklung',
    img: require('../../assets/img/aboutUs/Christoph.png'),
    title: 'Christoph ist gestandener Vollblut-Architekt (und -Innerrhödler), dem der nachhaltige Schutz des Raumes schwer am Herzen liegt. Mit seinem Domänenwissen und seiner grossen Erfahrung sorgt er mit Verve dafür, dass unser Potenzialrechner und unsere Dienstleistungen im Bereich der Immobilienentwicklung immer besser und besser werden.',
    description: `
      </div>
        <div style="font-weight: 600">Was Christoph mag:</div>
        <div>Kellogg’s Choco Crispies, die Mata Atlântica, lange Nächte mit altem Whisky und guten Freunden, Kaffii-Flämmli, Arbeiten in kurzen Hosen, Würfel und das Nebelmeer (wenn darüber).</div>
        <br>
        <div style="font-weight: 600">Was Christoph nicht mag:</div>
        <div>Bücher ohne Bilder, Kalorienzähler, Paartanz, wenn Schneefall in Regen übergeht, Shopping und das Nebelmeer (wenn darunter).</div>
      </div>
    `
  },
  {
    firstName: 'Magdalena',
    lastName: 'Haslinger',
    open: false,
    email: 'magdalena@raumpioniere.ch',
    position: 'Architektur & Entwicklung',
    img: require('assets/img/aboutUs/magdalena_1.png'),
    title: 'Als Architektin sichert Magdalena zusammen mit Christoph die Qualität unseres Potenzialrechners und unserer Dienstleistungen; sprich: sie liebt es, Eigentümerinnen und Eigentümer mit ihrem Know-how zu beraten und Immobilien aller Art state-of-the-art zu entwickeln – immer auf dem Weg zu neuen Pioniertaten.',
    description: `
      </div>
        <div style="font-weight: 600">Was Magdalena mag:</div>
        <div>Spannende Diskussionen, Poweryoga, Über-Den-Tellerand-Schauer*innen, Sneakers, grüne Smoothies, Gedankensprünge,  Powernaps, Aperol Spritz, Science-Fiction-Romane, Wortwitze, Faultiere.</div>
        <br>
        <div style="font-weight: 600">Was Magdalena nicht mag:</div>
        <div>unflexible Menschen, Nein-Sager, Horrorfilme, Trotinetten, in-der-Schlange stehen, Marzipan, Kälte, Spinnen, Stress.</div>
      </div>
    `
  },
  {
    firstName: 'Tamás Attila',
    lastName: 'Kiss',
    open: false,
    email: 'tamas@raumpioniere.ch',
    position: 'Marketing & PR',
    img: require('../../assets/img/aboutUs/Tamas.png'),
    title: `
      <div>
        <div>Tamás ist studierter Jurist und erfahrener Marketeer, der über den grossen Oscar Niemeyer in die Welt des Planens und Bauens gerutscht ist. Als Creative Director ist er für die Marke RAUMPIONIERE und deren unverkennbare Sprache zuständig.</div>
      </div>
    `,
    description: `
      </div>
        <div style="font-weight: 600">Was Tamás mag:</div>
        <div>Zuerst und vor allem: meine Familie, maximale Selbstbestimmung, Glaube & Hingabe, Grosszügigkeit, Gelassenheit, Sommer, zeitgenössische Kunst, Zürich, die Tropen, Katzen, Schlafwagen und Hochmoore.</div>
        <br>
        <div style="font-weight: 600">Was Tamás nicht mag:</div>
        <div>Dummheit, Saturiertheit, Überheblichkeit, Unsensibilität, Unpünktlichkeit, öffentliche WCs, amerikanische Zollbeamte, Pessimisten, Profilneurotiker und die Fasnacht.</div>
      </div>
    `
  },
  {
    firstName: 'Marco',
    lastName: 'Tamburlini',
    open: false,
    email: 'marco@raumpioniere.ch',
    position: 'Legal Advisor',
    img: require('../../assets/img/aboutUs/Marco.png'),
    title: 'Marco Tamburlini ist Rechtsanwalt, Gründungspartner von Bratschi St. Gallen bzw. deren Vorgänger- Organisation. Er berät hauptsächlich KMU in wirtschaftsrechtlichen Fragestellungen und begleitet einige Start-Ups.',
    description: `
          </div>
            <div style="font-weight: 600">Was Marco mag:</div>
            <div>vor allem meine Familie mit unseren drei Töchtern, Unabhängigkeit im weitesten Sinne, Outdoor-Aktivitäten mit Sonne und Wärme, FC St. Gallen, Rotwein, Bratwurst.</div>
            <br>
            <div style="font-weight: 600">Was Marco nicht mag:</div>
            <div>Arroganz und Überheblichkeit, geizige Menschen, kalte Temperaturen, gebratenen Fisch.</div>
          </div>
        `
  },
  {
    firstName: 'Barnabás',
    lastName: 'Tóth',
    email: 'barnabas@raumpioniere.ch',
    position: 'Senior Developer',
    img: require('../../assets/img/aboutUs/Barna.png'),
    title: `
      <div>
        <div>Barna sitzt in Budapest und hat sich, um unsere Lösungen zu programmieren, erstmal eine eigene Tastatur entwickelt. Wenn er mal nicht am Programmieren ist, zieht er mit seiner Freundin durch die Stadt.</div>
      </div>
    `,
    description: `
      </div>
        <div style="font-weight: 600">Was Barna mag:</div>
        <div>Abstraktes Denken, Bier, Hunde, Philosophie, Programmieren, gute Musik, das Verlassen meiner Komfortzone, Vielfalt, Menschen, die fähig sind, ihre Meinung auch mal zu revidieren.</div>
        <br>
        <div style="font-weight: 600">Was Barna nicht mag:</div>
        <div>Egozentrische Menschen, schlechte Musik, Sinn- und nutzloses Handeln.</div>
      </div>
    `
  }
])
members.value = members.value.sort((a, b) => a.lastName > b.lastName ? 1 : -1)
function closeRow (member, num, group) {
  gsap.to(`.team--selected-box-${num}`, {
    duration: 1,
    maxHeight: '0px',
    marginBottom: '0px',
    marginTop: '0px',
    onComplete: () => {
      member.open = false
      disabled.value = false
      if (group) {
        group.member = null
        group.open = false
      }
    }
  })
}

const memberClicked = (member, num, group) => {
  if (disabled.value) {
    setTimeout(() => {
      memberClicked(member, num, group)
    }, 500)
    return
  }
  if (screen.gt.xs) {
    if (group.open && group.member && group.member.firstName === member.firstName) {
      closeRow(member, num, group)
    } else {
      group.member = member
      if (!group.open) {
        disabled.value = true
      }
      if (group.member && group.member.title && group.member.description) {
        group.open = true
        gsap.to(
          `.team--selected-box-${num}`,
          {
            duration: 1,
            maxHeight: '1000px',
            marginTop: screen.gt.xs ? '50px' : '0px',
            marginBottom: screen.gt.xs ? '100px' : '30px',
            onComplete: () => {
              disabled.value = false
            }
          }
        )
      } else {
        closeRow(member, num, group)
      }
    }
  } else {
    if (member.open) {
      closeRow(member, num, null)
    } else {
      if (member.title && member.description) {
        member.open = !member.open
        gsap.to(
          `.team--selected-box-${num}`,
          {
            duration: 1,
            maxHeight: '1000px',
            marginTop: screen.gt.xs ? '50px' : '0px',
            marginBottom: screen.gt.xs ? '100px' : '30px'
          }
        )
      } else {
        closeRow(member, num, null)
      }
    }
  }
}

const groups = ref([])
watch(screen, () => {
  const res = []
  let memberPerRow
  if (screen.gt.md) {
    memberPerRow = 4
  } else if (screen.gt.sm) {
    memberPerRow = 3
  } else if (screen.gt.xs) {
    memberPerRow = 2
  } else {
    memberPerRow = 1
  }
  let counter = 1
  for (let i = 0; i < (members.value.length); i++) {
    if (counter === 1) {
      res.push({
        open: false,
        member: null,
        row: [members.value[i]]
      })
      counter++
    } else if (counter === memberPerRow) {
      res[res.length - 1].row.push(members.value[i])
      counter = 1
    } else {
      res[res.length - 1].row.push(members.value[i])
      counter++
    }
  }
  groups.value = res
}, { immediate: true, deep: true })
</script>

<template lang="pug">
.team--content
  .gt-xs.team--row-container(v-for="(group, groupIndex) in groups" :key="groupIndex" :class="`team--row-container-${groupIndex}`")
    .team--row(:class="`team--row-${groupIndex}`")
      .team--member(v-for="member in group.row" :key="member.firstName" @click="memberClicked(member, groupIndex, group)")
        img.team--member-img(:src="member.img")
        .team--member-name(:class="member.firstName === (group.member ? group.member.firstName : null) ? 'team-member-title-highlighted' : ''") {{ `${member.firstName} ${member.lastName}` }}
        .team--member-title(:class="member.firstName === (group.member ? group.member.firstName : null) ? 'team-member-title-highlighted' : ''") {{ member.position }}
    .team--selected-box(:class="`team--selected-box-${groupIndex}`")
      .team--selected-title(v-html="group.member ? group.member.title : ''")
      .team--content-description(v-html="group.member ? group.member.description : ''")
  .team--row.lt-sm(v-for="(member, memberIndex) in members" :key="member.firstName")
    .team--member(@click="memberClicked(member, memberIndex, null)")
      img.team--member-img(:src="member.img")
      .team--member-name(:class="member.open ? 'team-member-title-highlighted' : ''") {{ `${member.firstName} ${member.lastName}` }}
      .team--member-title(:class="member.open ? 'team-member-title-highlighted' : ''") {{ member.position }}
    .team--selected-box(:class="`team--selected-box-${memberIndex}`")
      .team--selected-title(v-html="member.open ? member.title : ''")
      .team--content-description(v-html="member.open ? member.description : ''")
</template>

<style lang="sass">
.team--content
  @media screen and (min-width: 1024px)
    margin-top: 100px
  @media screen and (max-width: 1024px) and (min-width: 600px)
    margin-top: 75px
    padding: 0 25px
  @media screen and (max-width: 600px)
    margin-top: 50px
    padding: 0 15px
  .team--row-container
    margin-bottom: 0px
  .team--row
    display: grid
    @media screen and (min-width: 1440px)
      padding-bottom: 50px
      grid-template-columns: repeat(4, minmax(0, 1fr))
      grid-column-gap: 40px
    @media screen and (max-width: 1440px) and (min-width: 1024px)
      padding-bottom: 40px
      grid-template-columns: repeat(3, minmax(0, 1fr))
      grid-column-gap: 30px
    @media screen and (max-width: 1024px) and (min-width: 600px)
      grid-template-columns: repeat(2, minmax(0, 1fr))
      grid-column-gap: 20px
    @media screen and (max-width: 600px)
      grid-gap: 30px
  .team--member
    cursor: pointer
    display: flex
    flex-direction: column
    .team--member-img
      flex: 1
      border-radius: 10px
      overflow: hidden
      object-fit: cover
      width: 100%
      @media screen and (min-width: 1024px)
      @media screen and (max-width: 1024px)
    .team-member-title-highlighted
      color: #007BFF !important
    .team--member-name
      margin-top: 10px
      font-weight: 700
      line-height: 125%
      color: #22223C
      transition: 0.3s color ease-in-out
      @media screen and (min-width: 1024px)
        font-size: 20px
      @media screen and (max-width: 1024px)
        font-size: 16px
    .team--member-title
      font-weight: 400
      line-height: 125%
      color: #22223C
      transition: 0.3s color ease-in-out
      margin-top: 3px
      @media screen and (min-width: 1024px)
        font-size: 20px
      @media screen and (max-width: 1024px)
        font-size: 16px
  .team--selected-box
    height: auto
    max-height: 0px
    padding-top: 0px
    overflow: hidden
    display: grid
    @media screen and (min-width: 1024px)
      grid-gap: 40px
      grid-template-columns: 1fr 1fr
    @media screen and (max-width: 1024px)
      grid-gap: 20px
    .team--selected-title
      font-weight: 600
      line-height: 162%
      color: #22223C
      @media screen and (min-width: 1024px)
        font-size: 16px
      @media screen and (max-width: 1024px)
        font-size: 14px
    .team--content-description
      line-height: 162%
      color: #22223C
      @media screen and (min-width: 1024px)
        font-size: 16px
      @media screen and (max-width: 1024px)
        font-size: 14px
</style>
